import { SampleDownloadModelData } from './models/SampleDownloadModel'
import { AdminSampleDownloadService } from './api/AdminSampleDownloadService'

const SampleDownloadModule = {
  namespaced: true,
  state: SampleDownloadModelData(),
  actions: {
    /**
     * Get publishers list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param paramaters | string
     */
    async getFile ({ dispatch }, { resolve, reject, fileName }) {
      try {
        const response = await AdminSampleDownloadService.getFile(fileName)
        resolve && resolve(response.data)
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default SampleDownloadModule
